// eslint-disable-next-line import/no-cycle
import { IReducerState } from 'store/main-reducer'; // It's a type
import {
  IPlan, IWorkItOutData, PromoCodeDiscount, IPickAPlanData, IContactDetails, ICompanyDetails, ISubmitPayload, ISummary, IPayroll, ISubmitData,
} from 'types';
import { OPTION_OTHER, PLAN_IDS } from '../app/constants';

export function getWorkItOutData(state: IReducerState): IWorkItOutData {
  return state.signUpReducer.workItOut;
}

export function getIsCalcOnly(state: IReducerState): boolean {
  return state.signUpReducer.pickAPlan.chosenPlan === PLAN_IDS.CALCULATE_ONLY;
}

export function getBank(state: IReducerState): string {
  const { bankChoice } = state.signUpReducer.workItOut;

  if (bankChoice?.name === OPTION_OTHER) {
    return state.signUpReducer.workItOut.bankOther || bankChoice.name;
  }

  return state.signUpReducer.workItOut.bankChoice?.name || '';
}

export function getPickAPlanData(state: IReducerState): IPickAPlanData {
  return state.signUpReducer.pickAPlan;
}

export function getChosenPlan(state: IReducerState): string {
  return state.signUpReducer.pickAPlan.chosenPlan;
}

export function getChosenExtras(state: IReducerState): string[] {
  return state.signUpReducer.pickAPlan.extras;
}

export function getIsCharity(state: IReducerState): boolean {
  return state.signUpReducer.isCharity;
}

export function getDefaultPromoCode(state: IReducerState): string | undefined {
  return state.signUpReducer.defaultPromoCode;
}

export function getPromoCodeDiscount(state: IReducerState): PromoCodeDiscount | undefined {
  return state.signUpReducer.promoCode.discount;
}

export function getPromoCodeIsLoading(state: IReducerState): boolean {
  return state.signUpReducer.promoCode.isLoading;
}

export function getPromoCodeIsSuccess(state: IReducerState): boolean {
  return state.signUpReducer.promoCode.isSuccess;
}

export function getPromoCodeIsFailure(state: IReducerState): boolean {
  return state.signUpReducer.promoCode.isFailure;
}

export function getPromoCodeErrorMessage(state: IReducerState): string | undefined {
  return state.signUpReducer.promoCode.error;
}

export function getReferralCode(state: IReducerState): string {
  return state.signUpReducer.summary.referralCode;
}

export function getChosenPlanData(state: IReducerState): IPlan | undefined {
  const chosenPlanOptions = state.optionsReducer.options?.plans;
  const chosenPlanId = state.signUpReducer.pickAPlan.chosenPlan;

  if (!chosenPlanOptions || !chosenPlanId) {
    return undefined;
  }

  return chosenPlanOptions.find(({ id }) => chosenPlanId === id);
}

export function getContactDetailsData(state: IReducerState): IContactDetails | undefined {
  return state.signUpReducer.contactDetails;
}

export function getCallbackRequestModalDefaults(state: IReducerState): ISubmitData | undefined {
  const primaryContact = state.signUpReducer.contactDetails?.contact;

  if (primaryContact) {
    return {
      firstName: primaryContact.firstName,
      lastName: primaryContact.lastName,
      email: primaryContact.email,
      phone: primaryContact.contactNumber,
    };
  }

  return undefined;
}

export function getCompanyDetailsData(state: IReducerState): ICompanyDetails | undefined {
  return state.signUpReducer.companyDetails;
}

export function getIsAccountant(state: IReducerState): boolean {
  return state.signUpReducer.contactDetails?.isAccountant || false;
}
export function getAccountantWillPaySmartPayrollFees(state: IReducerState): boolean {
  return state.signUpReducer.companyDetails?.accountantWillPaySmartPayrollFees || false;
}

export function getPayrollData(state: IReducerState): IPayroll | undefined {
  return state.signUpReducer.payrollInformation;
}

export function getSummaryData(state: IReducerState): ISummary {
  return state.signUpReducer.summary;
}

export function getSignUpSubmitIsLoading(state: IReducerState): boolean {
  return state.signUpReducer.isSubmitLoading;
}
export function getSignUpSubmitSucceeded(state: IReducerState): boolean {
  return state.signUpReducer.submitSuccess;
}
export function getSignUpSubmitFailed(state: IReducerState): string {
  return state.signUpReducer.submitError;
}
export function getSignUpHasSubmitted(state: IReducerState): boolean {
  return state.signUpReducer.hasSubmitted;
}

// Sign up data should only be called in the final step
export function getSignUpData(state: IReducerState): ISubmitPayload {
  const contactDetails = getContactDetailsData(state);
  const companyDetails = getCompanyDetailsData(state);
  const payroll = getPayrollData(state);
  const summary = getSummaryData(state);

  if (!contactDetails || !companyDetails || !payroll || !summary) {
    throw Error('Something went wrong');
  }

  return {
    workItOut: getWorkItOutData(state),
    pickAPlan: getPickAPlanData(state),

    isCharity: getIsCharity(state),
    promoCode: getPromoCodeDiscount(state),

    contactDetails,
    companyDetails,
    payrollInformation: payroll,
    summary,
  };
}
